import { render, staticRenderFns } from "./FunArenaLoot.vue?vue&type=template&id=b5120e48&scoped=true&"
import script from "./FunArenaLoot.vue?vue&type=script&lang=js&"
export * from "./FunArenaLoot.vue?vue&type=script&lang=js&"
import style0 from "./FunArenaLoot.vue?vue&type=style&index=0&id=b5120e48&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5120e48",
  null
  
)

export default component.exports